import * as Models from '@module/shared/components/Site/models';
import * as actionCreators from './actionCreators/siteActionCreators';

export const initialSitesState: Models.ISitesState = {
    sites: [],
    sitesLoading: false,
    pagingSettings: {
        skipItems: 0,
        pageSize: 20
    },
    sortingSettings: {
        sortDirection: 'asc',
        sortField: 'SiteName'
    },
    totalNumberOfSites: 0,
    searchFilter: '',
    siteSelected: false,
    selectedSite: Models.defaultSite,
    selectedSiteRegistered: false,
    siteRegister: {
        attempt: false,
        success: false,
        siteId: -1
    },
    fromServIs: false
};

export function sitesReducer(state = initialSitesState, action: any): any {
    switch (action.type) {
        case actionCreators.SITE_GET_REQUEST:
            return {
                ...state,
                sites: [],
                sitesLoading: true
            };
        case actionCreators.SITE_GET_SUCCESS:
            return {
                ...state,
                sites: action.sites,
                totalNumberOfSites: action.totalNumberOfSites,
                sitesLoading: false
            };
        case actionCreators.SITE_GET_ERROR:
            return {
                ...state,
                text: action.text,
                sitesLoading: false
            };
        case actionCreators.SITE_PAGING_CHANGE:
            return {
                ...state,
                pagingSettings: action.pagingSettings,
                sortingSettings: action.sortingSettings,
            };
        case actionCreators.SITE_SORT_CHANGE:
            return {
                ...state,
                pagingSettings: action.pagingSettings,
                sortingSettings: action.sortingSettings,
            };
        case actionCreators.SITE_APPLY_SEARCH:
            return {
                ...state,
                searchFilter: action.searchFilter,
                pagingSettings:  {
                    skipItems: 0,
                    pageSize: 20
                }
            };
        case actionCreators.SITE_SEARCH_CHANGE:
            return {
                ...state,
                searchFilter: action.searchFilter
            };
        default:
            return state;
    }
}
